// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #E5E7EB 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.3s ease-in-out infinite;
}
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/skeleton/index.scss"],"names":[],"mappings":"AAAA;EACE,yEAAA;EAMA,0BAAA;EACA,qDAAA;AAJF;AAME;EACE;IACE,2BAAA;EAJJ;EAME;IACE,4BAAA;EAJJ;AACF","sourcesContent":[".skeleton {\n  background: linear-gradient(\n                  90deg,\n                  #e0e0e0 25%,\n                  #E5E7EB 50%,\n                  #e0e0e0 75%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.3s ease-in-out infinite;\n\n  @keyframes skeleton-loading {\n    0% {\n      background-position: 200% 0;\n    }\n    100% {\n      background-position: -200% 0;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
